/* eslint-disable no-barrel-files/no-barrel-files */
// TODO: De-barrel-ize
import {
  OntologyField,
  OntologyFieldDefinition,
  useLoadOrganizationOntology,
} from 'features/dynamicOntology'
import {
  useHistogramQueries,
  type UseHistogramQueryProps,
} from 'features/dynamicOntology'

import {
  EXPLORER_BORDER_GRAY,
  EXPLORER_BORDER_GRAY_LOW_OPACITY,
  EXPLORER_GRAY,
  EXPLORER_HEADER_COLOR,
  EXPLORER_HIGHLIGHT_COLOR,
  EXPLORER_INPUT_GRAY,
  EXPLORER_TABLE_ROW_BACKGROUND,
} from './colors'
import { DrilldownPanel } from './components/DrilldownPanel'
import {
  CreatePanelButtons,
  CreatePanelButtonsProps,
  CreatePanelRequest,
} from './components/DrilldownPanelCreationButtons'
import DrilldownHeader from './components/header/DrilldownHeader'
import { HistogramPanelData } from './components/histogram/DrilldownHistogram'
import { URL_PATH_DRILLDOWN_EXPLORATION_VIEWER } from './components/landing/drilldownExplorationViewerUrls'
import {
  DRILLDOWN_PANEL_CONFIGS,
  DRILLDOWN_PANEL_INITIAL_DATA,
  DrilldownPanelInitialDataMap,
} from './components/panelConfigs/PanelConfigs'
import { DRILLDOWN_PANELS_TO_GROUPING_TYPES } from './components/panelConfigs/PanelGroupConfigs'
import {
  buildPanel,
  HistogramPanelRender,
  PanelRender,
} from './components/panelConfigs/PanelRenderUtils'
import { PanelCreationButtonsZone } from './components/PanelCreationButtonsZone'
import { DrilldownExplorationPickerProps } from './components/settings/DrilldownExplorationPicker'
import { DrilldownSettingsView } from './components/settings/DrilldownSettingsView'
import { useDefaultFilters } from './data/defaultFilters'
import {
  DrilldownFilterContext,
  DrilldownFilterContextType,
  useFilters,
  useFilterToIds,
  useFilterToSites,
  useFilterToValues,
  useGetPrecedingFilters,
} from './data/DrilldownFilterContext'
import { DrilldownPanelCreationContext } from './data/DrilldownPanelCreationContext'
import {
  DrilldownPanelDataContext,
  useDrilldownPanelData,
  useVersionAwareDrilldownPanelData,
} from './data/DrilldownPanelDataContext'
import {
  DEFAULT_COLUMN_WIDTH,
  DEFAULT_EMPTY_VIEW_STATE,
  DrilldownDataContext,
  DrilldownExplorationProvider,
  DrilldownExplorationProviderProps,
} from './data/savedExplorationState/DrilldownExplorationContext'
import {
  DEFAULT_EXPLORATION_NAME,
  RolodexDrilldownExplorationState,
  useRolodexExplorationsForUser,
  useSaveExplorationToRolodex,
} from './data/savedExplorationState/rolodexApi/rolodexDrilldownExplorationStateApi'
import { useRolodexBoundDrilldownExplorations } from './data/savedExplorationState/rolodexBoundDrilldownExplorationState'
import {
  ColumnBreakPanelData,
  DEFAULT_COLUMN_BREAK_PANEL_DATA,
} from './panels/global/columnBreak/columnBreak'
import {
  DEFAULT_WORK_ORDER_HISTOGRAM_PANEL_DATA,
  WORK_ORDER_HISTOGRAM_CONFIG_PROPS,
} from './panels/global/histogramPresets/workOrderHistogram'
import { useFilteredEntryQuery } from './rolodex/dataHelpers/drilldownDataHelpers'
import {
  useBufferedFilteredEntries,
  useFilteredEntries,
} from './rolodex/dataHelpers/useFilteredEntries'
import { buildUuid } from './utils/drilldownIdUtils'
import { copyTextToClipboard } from './utils/drilldownUxHelpers'

export {
  buildPanel,
  buildUuid,
  type ColumnBreakPanelData,
  copyTextToClipboard,
  CreatePanelButtons,
  type CreatePanelButtonsProps,
  type CreatePanelRequest,
  DEFAULT_COLUMN_BREAK_PANEL_DATA,
  DEFAULT_COLUMN_WIDTH,
  DEFAULT_EMPTY_VIEW_STATE,
  DEFAULT_EXPLORATION_NAME,
  DEFAULT_WORK_ORDER_HISTOGRAM_PANEL_DATA,
  DRILLDOWN_PANEL_CONFIGS,
  DRILLDOWN_PANEL_INITIAL_DATA,
  DRILLDOWN_PANELS_TO_GROUPING_TYPES,
  DrilldownDataContext,
  type DrilldownExplorationPickerProps,
  DrilldownExplorationProvider,
  DrilldownFilterContext,
  DrilldownHeader,
  DrilldownPanel,
  DrilldownPanelCreationContext,
  DrilldownPanelDataContext,
  type DrilldownPanelInitialDataMap,
  DrilldownSettingsView,
  EXPLORER_BORDER_GRAY,
  EXPLORER_BORDER_GRAY_LOW_OPACITY,
  EXPLORER_GRAY,
  EXPLORER_HEADER_COLOR,
  EXPLORER_HIGHLIGHT_COLOR,
  EXPLORER_INPUT_GRAY,
  EXPLORER_TABLE_ROW_BACKGROUND,
  type HistogramPanelData,
  HistogramPanelRender,
  type OntologyField,
  type OntologyFieldDefinition,
  PanelCreationButtonsZone,
  PanelRender,
  URL_PATH_DRILLDOWN_EXPLORATION_VIEWER,
  useBufferedFilteredEntries,
  useDefaultFilters,
  useDrilldownPanelData,
  useFilteredEntries,
  useFilteredEntryQuery,
  useFilters,
  useFilterToIds,
  useFilterToSites,
  useFilterToValues,
  useGetPrecedingFilters,
  useHistogramQueries,
  useLoadOrganizationOntology,
  useRolodexBoundDrilldownExplorations,
  useRolodexExplorationsForUser,
  useSaveExplorationToRolodex,
  useVersionAwareDrilldownPanelData,
  WORK_ORDER_HISTOGRAM_CONFIG_PROPS,
}

export type {
  DrilldownExplorationProviderProps,
  DrilldownFilterContextType,
  RolodexDrilldownExplorationState,
  UseHistogramQueryProps,
}

export { useDrilldownHistograms as useCountHistograms } from './rolodex/dataHelpers/drilldownDataHelpers'
export type {
  DrilldownExplorationConfiguration,
  DrilldownFocusItemsType,
  DrilldownPanelData,
  DrilldownPanelGroupType,
  DrilldownPanelState,
  DrilldownPanelType,
  DrilldownViewState,
  GenericPanelData,
} from './types'
